import React from "react";

import { parseDocType } from "EmployerApplication/Components/documentPicker/utils";

import BodyText from "Common/BodyText";
import { Ol } from "Common/HTML";

import type { UploadDocsProp } from "Utils/types";

export const intuitDocsDescription = (props: UploadDocsProp) => {
  const docType = parseDocType(props.fileInputName);

  switch (docType) {
    case "state_wage_report":
      return <StateWageReport {...props} />;
    case "payroll_journal":
      return <PayrollJournal {...props} />;
    case "w4":
      return <W4 {...props} />;
    default:
      return props.description;
  }
};

const StateWageReport = () => (
  <BodyText>
    Within{" "}
    <a href="https://qbo.intuit.com" target="_blank" rel="noreferrer">
      https://qbo.intuit.com
    </a>
    :
    <Ol my={2}>
      <li>
        From the left menu, select{" "}
        <BodyText componentClass="span" weight="bold">
          Taxes
        </BodyText>
        , then{" "}
        <BodyText componentClass="span" weight="bold">
          Payroll Tax
        </BodyText>
        .
      </li>
      <li>
        Click on the{" "}
        <BodyText componentClass="span" weight="bold">
          Filings
        </BodyText>{" "}
        Tab.
      </li>
      <li>
        Click on{" "}
        <BodyText componentClass="span" weight="bold">
          Archived Forms
        </BodyText>{" "}
        under Forms Resources.
      </li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          Quarterly Tax Forms
        </BodyText>{" "}
        from the drop-down.
      </li>
      <li>Find your form in the list.</li>
      <li>Select your form. Make sure that the document you select is from the correct quarter, and also is not the federal 941 form.</li>
      <li>
        Click{" "}
        <BodyText componentClass="span" weight="bold">
          View
        </BodyText>{" "}
        and download PDF.
      </li>
    </Ol>
    After downloading the PDF file, upload it here by clicking the input field below.
  </BodyText>
);

const PayrollJournal = (props) => (
  <BodyText>
    Within{" "}
    <a href="https://qbo.intuit.com" target="_blank" rel="noreferrer">
      https://qbo.intuit.com
    </a>
    :
    <Ol my={2}>
      <li>
        In the left navigation bar, select{" "}
        <BodyText componentClass="span" weight="bold">
          Reports
        </BodyText>
        .
      </li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          Payroll Summary
        </BodyText>
        .
      </li>
      {props.title == "Most recent 90-day company payroll journal" ? (
        <li>
          Once in the report, choose the most recent 90 days in the{" "}
          <BodyText componentClass="span" weight="bold">
            Date range
          </BodyText>{" "}
          drop-down on the upper left.
        </li>
      ) : (
        <li>
          Once in the report, choose{" "}
          <BodyText componentClass="span" weight="bold">
            Last month
          </BodyText>{" "}
          in the{" "}
          <BodyText componentClass="span" weight="bold">
            Date range
          </BodyText>{" "}
          drop-down on the upper left.
        </li>
      )}

      <li>
        Now select{" "}
        <BodyText componentClass="span" weight="bold">
          Run Report
        </BodyText>
        .
      </li>
      <li>
        After you run the report, select{" "}
        <BodyText componentClass="span" weight="bold">
          printer friendly
        </BodyText>{" "}
        (instead of share) from the drop-down in the upper right. The report will appear in a new window.
      </li>
      <li>
        In the new window, select{" "}
        <BodyText componentClass="span" weight="bold">
          File &rarr; Print
        </BodyText>
        , which will allow you to save the report as a PDF.
      </li>
    </Ol>
    After saving the report as PDF, upload it here by clicking the input field below.
  </BodyText>
);

const W4 = () => (
  <BodyText>
    A signed W-4 form is needed for each employee. You can scan and upload the completed W-4 form.
    <br />
    Within{" "}
    <a href="https://qbo.intuit.com" target="_blank" rel="noreferrer">
      https://qbo.intuit.com
    </a>
    :
    <Ol my={2}>
      <li>
        In the left navigation bar, select{" "}
        <BodyText componentClass="span" weight="bold">
          Taxes &rarr; Payroll Tax
        </BodyText>
        .
      </li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          Employee setup
        </BodyText>{" "}
        under{" "}
        <BodyText componentClass="span" weight="bold">
          Forms
        </BodyText>
        .
      </li>
      <li>In the drop-down on the left, select the employee.</li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          W-4
        </BodyText>
        .
      </li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          View
        </BodyText>
        , which opens the form in a new window. From here, you can download the PDF file.
      </li>
    </Ol>
    After downloading the PDF file, upload it here by clicking the input field below.
  </BodyText>
);
